import { z } from "zod";

const machineGroupStatuses = [
	"ChangingCorrugate",
	"Error",
	"Initializing",
	"MachineService", // @deprecated use service instead no usage in Production found
	"NoMachinesConfigured",
	"Offline",
	"Online",
	"Paused",
	"Service",
	"UnknownMachineGroupStatus",
	"AirplaneMode",
] as const;

export const machineGroupStatusSchema = z.enum(machineGroupStatuses);

export type MachineGroupStatus = z.infer<typeof machineGroupStatusSchema>;
